import React from 'react';
import './Map.css';
import MapImage from '../assets/mapa.png';

const MapSection = () => {
  return (
    <section className="map-section">
      <div className="map-box">
        <div className="map-image-wrapper">
          <img src={MapImage} alt="Mapa da localização" className="map-image" />
          
          <div className="map-overlay">
            <h2 className="map-title">LOCALIZAÇÃO</h2>
            <p className="map-address">
              São Caetano do Sul-SP, 09070-210,<br />
              Alameda São Caetano, 135; Santa Paula
            </p>
            <p className="map-hours">
              Segunda à sexta das 05h às 00h<br />
              Sábado, domingo e feriados das 08h às 20h
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default MapSection;
